<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="document-container">
    <div class="document-wrap">
      <div class="document-title">
        <span>{{ dataFile.name }}</span>
      </div>
      <div class="header-buttons">
        <a v-if="dataFile.format.indexOf('application/pdf') !== -1 && dataFile.url" :href="dataFile.url" target="_blank">
          <div v-tooltip="$t('show_pdf')" class="button-wrapper">
            <div class="icon-pdf" />
          </div>
        </a>
        <div
          v-if="dataFile.url"
          @click="download(dataFile.url, dataFile.name)"
        >
          <div v-tooltip="$t('download_file')" class="button-wrapper">
            <div class="icon-download" />
          </div>
        </div>
        <a v-if="dataFile.format.indexOf('text/plain') !== -1" :href="dataFile.url" target="_blank">
          <div v-tooltip="$t('show_txt')" class="button-wrapper">
            <div class="icon-txt" />
          </div>
        </a>
        <a v-else-if="dataFile.text && dataFile.text.url" :href="dataFile.text.url" target="_blank">
          <div v-tooltip="$t('show_txt')" class="button-wrapper">
            <div class="icon-txt" />
          </div>
        </a>
      </div>
    </div>
    <div v-if="single" class="file-preview">
      <div v-if="dataFile.thumbnail && dataFile.thumbnail.url" class="img-thumb" :style="'background-image: url(' + dataFile.thumbnail.url + ')'" />
      <span v-else class="file-name">{{ dataFile.name }}</span>
    </div>
  </div>
</template>

<script>
import { savedownload } from '../../services/api'
import { saveAs } from 'file-saver'
/**
 * Document Addition view disposition
 * @example [none]
 */
export default {
  name: 'DocumentAddition',
  components: {},
  props: {
    dataFile: {
      type: Object,
    },
    single: {
      type: Boolean,
    },
  },
  computed: {},
  methods: {
    
    /* TO REVIEW DOWNLOAD_FILE FUNCTION */
    
    download_file(fileURL, fileName) {
      // var oReq = new XMLHttpRequest()
      // // The Endpoint of your server
      
      // //var URLToPDF = "https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf"
      // var URLToPDF = fileURL

      // // Configure XMLHttpRequest
      // oReq.open("GET", URLToPDF, true)

      // // Important to use the blob response type
      // oReq.responseType = "blob"

      // // When the file request finishes
      // // Is up to you, the configuration for error events etc.
      // oReq.onload = function() {
      //   // Once the file is downloaded, open a new window with the PDF
      //   // Remember to allow the POP-UPS in your browser
      //   var file = new Blob([oReq.response], { 
      //       type: 'application/pdf' 
      //   })
      //   debugger
      //   // Generate file download directly in the browser !
      //   saveAs(file, fileName)
      // }

      // oReq.send()
      
      saveAs(fileURL, fileName)
    },
    download(url, name) {
      this.download_file(url, name)
      savedownload(this.$route.params.lang, this.$route.params.cardId, name)
    },
  },
}
</script>

<style lang="stylus" scoped>
.document-container
  display: flex
  flex-direction: column
  border-bottom: 1px solid $light-grey
  margin-bottom: vw(15px)
  padding-bottom: vw(15px)
  
  .document-wrap
    display: flex
    justify-content: space-between
    align-items: center
    gap: vw(10px)
    
    .document-title
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
      overflow: hidden
      
      span
        m-font-size(14, 18)
        font-weight: 400
        color: $grey-dark

    .header-buttons
      display: flex
      gap: vw(12px)

      .button-wrapper
        display: flex
        justify-content: center
        align-items: center
        width: vw(32px)
        height: vw(32px)
        border: 1px solid $grey-dark
        border-radius: 50%
        background-color: white
        cursor: pointer

        &:hover
          border: 1px solid $bcn-other-light-grey
          background-color: $bcn-other-light-grey

        .icon-pdf
          m-icon("eye", 16)

        .icon-download
          m-icon("download-black", 16)

        .icon-txt
          m-icon("text-black", 16)

  .file-preview
    display: flex
    justify-content: center
    margin-bottom: vw(15px)
    width: 100%

    .img-thumb
      width: 100%
      height: 250px
      background-position: center center
      background-size: contain
      background-repeat: no-repeat
</style>
